var e=new Map,t=0,n={bookId:function(){return"x:".concat(t++)},register:function(t,n){return e.set(t,n),t},get:function(t){return e.get(t)},free:function(t){e.delete(t)}};export{n as registry};
//# sourceMappingURL=registry.js.map
